import ReactNativeFile from "@repo/graphql/client/file";
import { useCallback, useState } from "react";

export const useDraggableFiles = () => {
  const [isDragging, setIsDragging] = useState(false);
  const handleDragOver = useCallback((e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  }, []);

  const handleDragLeave = useCallback((e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  }, []);

  const fileToRNFile = useCallback(async (file: File) => {
    const reader = new FileReader();
    return new Promise<ReactNativeFile>((resolve) => {
      reader.onload = (e) => {
        resolve(
          new ReactNativeFile({
            uri: e.target?.result as string,
            name: file.name,
            type: file.type,
            fileSize: file.size,
          }),
        );
      };
      reader.readAsDataURL(file);
    });
  }, []);

  const dropToRnFiles = useCallback(
    async (e: React.DragEvent<HTMLDivElement>) => {
      e.preventDefault();
      e.stopPropagation();
      setIsDragging(false);
      const files = Array.from(e.dataTransfer.files);
      const newFiles = files.map(fileToRNFile);
      return await Promise.all(newFiles);
    },
    [fileToRNFile],
  );

  const draggableProps: React.HTMLAttributes<HTMLDivElement> = {
    onDragOver: handleDragOver,
    onDragLeave: handleDragLeave,
  };

  return { isDragging, dropToRnFiles, draggableProps };
};
